(() => {
  const prepare = video => {
    let changed = false;
    video.querySelectorAll('source[data-cc-src]').forEach(source => {
      source.src = source.dataset.ccSrc;
      source.removeAttribute('data-cc-src');
      changed = true;
    });
    return changed;
  };
  document.addEventListener('click', event => {
    const player = event.target.closest('internal-video');
    const video = player?.querySelector('video[data-cc-demand-video]');
    if (!video || !event.target.closest('.internal-video__play,video')) return;
    prepare(video);
  }, true);
})();
